import React, { useEffect, Fragment, useState } from "react";
import {
  Button,
  Input,
  message,
  Form,
  Modal,
  Row,
  Col,
  Tooltip,
  Spin,
  Space,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  hideMessage,
  showAuthLoader,
  userSignIn,
} from "../appRedux/actions/Auth";
// import IntlMessages from "../util/IntlMessages"
import CircularProgress from "../components/CircularProgress/index";
import { LogoBareskrim } from "../assets/geospatial/images/provide.images";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import RedoOutlined from "@ant-design/icons/lib/icons/RedoOutlined";
import CheckCircleFilled from "@ant-design/icons/lib/icons/CheckCircleFilled";
import CloseCircleOutlined from "@ant-design/icons/lib/icons/CloseCircleOutlined";
import moment from "moment";
import { Helmet } from "react-helmet";
import LoginVideo from "../assets/geospatial/images/Login/login.mp4";
import { map, isEmpty } from "lodash";
import {
  verifyAuth,
  getAppId,
  verifyCaptchaLogin,
  // verifyOTPLogin,
  resendOTP,
} from "../apis/login/login_read";
import Cookies from "js-cookie";
import IntlMessages from "../util/IntlMessages";
import { secondsToTime } from "../util/Transformer";
const OtpInput = ({ length = 6, onChange }) => {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputsRef = React.useRef([]);

  const handleChange = (value, idx) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[idx] = value;
    setOtp(newOtp);
    onChange && onChange(newOtp.join("")); // kirim string ke parent
    if (value && idx < length - 1) {
      inputsRef.current[idx + 1].focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !otp[idx] && idx > 0) {
      inputsRef.current[idx - 1].focus();
    }
  };

  return (
    <Space>
      {otp.map((digit, idx) => (
        <Input
          key={idx}
          value={digit}
          maxLength={1}
          style={{
            width: 50,
            height: 50,
            textAlign: "center",
            marginBottom: "10px",
          }}
          ref={(el) => (inputsRef.current[idx] = el)}
          onChange={(e) => handleChange(e.target.value, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
        />
      ))}
    </Space>
  );
};

const SignIn = () => {
  const [form] = Form.useForm();
  const [captchaForm] = Form.useForm();
  const [otpForm] = Form.useForm();
  const [oneUserAppId, setOneUserAppId] = useState("");

  const [Loading, setLoading] = useState(false);
  const [showModalOTP, setShowModalOTP] = useState(false);
  const [email, setEmail] = useState("");

  const [captcha, setCaptcha] = useState([]);

  const [openCaptcha, setOpenCaptcha] = useState(false);
  const [loadingCaptcha, setLoadingCaptcha] = useState(false);
  const [captchaBg, setCaptchaBg] = useState({});

  const [captchaSuccess, setCaptchaSuccess] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [loadingOtp, setLoadingOtp] = useState(false);
  const [dataOtp, setDataOtp] = useState("");
  const [counter, setCounter] = useState(90);

  const device = "0";
  const application =
    "65adf62f81e5f64101f1eecb8443153cf2e172e57e3e740282423dc5fe130757";

  const dispatch = useDispatch();
  const { loader, alertMessage, showMessage, authUser } = useSelector(
    ({ auth }) => auth
  );
  const history = useHistory();

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }
    if (authUser !== null) {
      history.push("/");
    }
  });

  useEffect(() => {
    if (showModalOTP === true) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [counter, showModalOTP]);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // const onFinish = (values) => {
  //   console.log(values, "ini value");
  // dispatch(showAuthLoader());
  // dispatch(userSignIn(values));
  // };

  const showModal = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const checkAppIds = async (values) => {
    const body = {
      username: values.username,
      password: values.password,
    };

    try {
      setCaptchaSuccess(false);
      if (isEmpty(Cookies.get("ap_d"))) {
        setLoading(true);
        const response = await getAppId(body);

        if (response.status === "OK") {
          const arr = [
            {
              username: response.data.userName,
              app_id: response.data.app_id,
            },
          ];

          Cookies.set("ap_d", JSON.stringify(arr), {
            expires: 14,
          });
          await onFinishLogin(response.data.app_id);
        }
        setOneUserAppId(response.data.app_id);
      } else {
        const ap_d_raw = await Cookies.get("ap_d");
        const ap_d = ap_d_raw ? JSON.parse(ap_d_raw) : [];
        // await onFinishLogin(ap_d);
        // setOneUserAppId(ap_d);
        // console.log(ap_d, "ini apa");
        // const filterData = ap_d.filter((e) => {
        //   return e.username === values.username;
        // });
        // console.log(filterData, "ini data");
        if (
          ap_d?.some((e) => {
            return e.username === values.username;
          })
        ) {
          const filteredUserId = ap_d.filter((e) => {
            return e.username === values.username;
          });
          setOneUserAppId(filteredUserId[0].app_id);
          onFinishLogin(filteredUserId[0].app_id);
        } else {
          setLoading(true);
          const reqAppId2 = await getAppId(body);

          if (reqAppId2.status === "OK") {
            setLoading(false);
            const newArr = [
              ...ap_d,
              {
                username: reqAppId2.data.userName,
                app_id: reqAppId2.data.app_id,
              },
            ];
            setOneUserAppId(reqAppId2.data.app_id);
            onFinishLogin(reqAppId2.data.app_id);

            Cookies.set("ap_d", JSON.stringify(newArr), {
              expires: 14,
            });
          }
        }
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Terjadi kesalahan saat login";

      setLoading(false);
      if (errorMsg.includes("AUTH_WRONG_USERNAME_PASSWORD")) {
        setLoading(false);
        form.setFields([
          {
            name: "username",
            errors: [<IntlMessages id="app.userAuth.checkUser" />],
          },
          {
            name: "password",
            errors: [<IntlMessages id="app.userAuth.checkPassword" />],
          },
        ]);
        message.error("Username dan Kata Sandi Tidak Sesuai");
      } else if (
        errorMsg.includes("USER_SUSPENDED_DUE_TO_TOO_MANY_ATTEMPTS") ||
        errorMsg.includes("USER_SUSPENDED")
      ) {
        showModal();
      } else {
        message.error("Terjadi kesalahan saat login, mohon coba lagi");
        setLoading(false);
        Cookies.remove("ap_d");
        console.log(error);
      }
    }
  };

  const onFinishLogin = async (values) => {
    try {
      setLoading(true);
      setLoadingCaptcha(true);
      setCaptchaSuccess(false);

      const body = {
        username: form.getFieldValue("username"),
        password: form.getFieldValue("password"),
        device: device,
        application: application,
        app_id: values,
      };

      const reqVerify = await verifyAuth(body);

      if (reqVerify.status === "OK") {
        const min = Math.ceil(-40);
        const max = Math.floor(40);
        if (reqVerify.data.type === "captcha") {
          let counts = [];
          let bgRotate = Math.floor(Math.random() * (max - min + 1)) + min;

          for (let i = 0; i < 6; i++) {
            let count = 0;
            let loopEnd = Math.floor(Math.random() * (max - min + 1)) + min;
            for (let j = 0; j < loopEnd; j++) {
              count++;
            }
            counts.push(count);
          }

          setOpenCaptcha(true);
          setLoadingCaptcha(true);

          setCaptcha(
            map(reqVerify.data?.en_img, (data, index) => {
              return {
                image: data,
                position: reqVerify.data.posY[index],
                rotates: counts[index],
              };
            })
          );

          setCaptchaBg({
            background: reqVerify.data?.en_bg,
            bgRotate: bgRotate,
          });
        } else if (reqVerify.data.type === "otp") {
          setCaptchaSuccess(true);
          setTimeout(() => {
            setLoadingCaptcha(false);
            setLoadingOtp(false);
            setLoading(false);
            setOpenCaptcha(false);
            message.info(
              "Mohon input kode OTP yang kami kirim ke email anda",
              6
            );
          }, 500);
          setTimeout(() => {
            setShowModalOTP(true);
            // setDataOtp(String(reqVerify.data.otp).split("").map(Number));
          }, 1400);
        } else if (reqVerify.data.type === "login") {
          const body = {
            username: form.getFieldValue("username"),
            password: form.getFieldValue("password"),
            device: device,
            application: application,
            app_id: values,
          };

          dispatch(showAuthLoader());
          dispatch(userSignIn(body));
        }
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Terjadi kesalahan saat login";

      setLoading(false);
      if (errorMsg.includes("AUTH_WRONG_USERNAME_PASSWORD")) {
        setLoading(false);
        form.setFields([
          {
            name: "username",
            errors: [<IntlMessages id="app.userAuth.checkUser" />],
          },
          {
            name: "password",
            errors: [<IntlMessages id="app.userAuth.checkPassword" />],
          },
        ]);
        message.error("Username dan Kata Sandi Tidak Sesuai");
      } else if (
        errorMsg.includes("USER_SUSPENDED_DUE_TO_TOO_MANY_ATTEMPTS") ||
        errorMsg.includes("USER_SUSPENDED")
      ) {
        showModal();
      } else {
        message.error("Terjadi kesalahan saat login, mohon coba lagi");
        setLoading(false);
        Cookies.remove("ap_d");
      }
    } finally {
      setLoading(false);

      setTimeout(() => {
        setLoadingCaptcha(false);
      }, 1200);

      setTimeout(() => {
        setCaptchaSuccess(false);
      }, 1300);
    }
  };

  const onVerifyCaptcha = async (values) => {
    try {
      setCaptchaSuccess(false);
      setLoadingCaptcha(true);
      const body = {
        username: form.getFieldValue("username"),
        password: form.getFieldValue("password"),
        device: device,
        application: application,
        answer: values.captchaInput,
        app_id: oneUserAppId,
      };

      const response = await verifyCaptchaLogin(body);

      if (response.status === "OK") {
        if (response.data.type === "otp") {
          setCaptchaSuccess(true);
          setTimeout(() => {
            setLoadingCaptcha(false);
            setLoading(false);
            setLoadingOtp(false);
            setOpenCaptcha(false);
            message.info(
              "Mohon input kode OTP yang kami kirim ke email anda",
              6
            );
          }, 1000);
          setTimeout(() => {
            setShowModalOTP(true);
            // setDataOtp(String(response.data.otp).split("").map(Number));
          }, 1400);

          setEmail(response.data.email);
        } else if (response.data.type === "login") {
          setTimeout(() => {
            setCaptchaSuccess(true);
          }, 500);

          setTimeout(() => {
            message.success("Login Success");
          }, 1000);

          setTimeout(() => {
            setLoadingCaptcha(false);
            setOpenCaptcha(false);
            const body = {
              username: form.getFieldValue("username"),
              password: form.getFieldValue("password"),
              device: device,
              application: application,
              answer: values.captchaInput,
              app_id: oneUserAppId,
            };
            dispatch(showAuthLoader());
            dispatch(userSignIn(body));
          }, 1400);

          setTimeout(() => {
            setLoadingCaptcha(false);
            setLoadingOtp(false);
            setLoading(false);
          }, 10000);
        }
      }
    } catch (error) {
      setCaptchaSuccess(false);
      setLoadingCaptcha(false);
      if (error.response?.data?.message.includes("captcha not match")) {
        captchaForm.setFields([
          {
            name: "captchaInput",
            errors: [<IntlMessages id="app.userAuth.captchaMatch" />],
            value: "",
          },
        ]);
        onFinishLogin(oneUserAppId);
      } else {
        message.error(
          "Terjadi kesalahan saat memasukan captcha, mohon coba lagi"
        );
        onFinishLogin(oneUserAppId);
        captchaForm.setFields([
          {
            name: "captchaInput",
            errors: [""],
            value: "",
          },
        ]);
      }
    }
  };

  const onVerifyOTP = async (values) => {
    try {
      // setLoadingOtp(true);
      // if (dataOtp.length === 0) {
      //   setTimeout(() => {
      //     setLoadingOtp(false);
      //   }, 10000);
      //   message.error(
      //     "Terjadi kesalahan saat memasukan captcha, mohon coba lagi"
      //   );
      // } else {
      //   setLoadingOtp(false);
      //   setShowModalOTP(false);
      //   const body = {
      //     username: form.getFieldValue("username"),
      //     password: form.getFieldValue("password"),
      //     device: device,
      //     application: application,
      //     otp: dataOtp.join(""),
      //     app_id: oneUserAppId,
      //   };

      //   dispatch(showAuthLoader());
      //   dispatch(userSignIn(body));
      // }
      // setLoadingOtp(true);
      // setShowModalOTP(true);
      if (dataOtp === "") {
        message.error("Kode OTP tidak boleh kosong");
      } else {
        const body = {
          username: form.getFieldValue("username"),
          password: form.getFieldValue("password"),
          device: device,
          application: application,
          otp: dataOtp,
          app_id: oneUserAppId,
        };

        // const response = await verifyOTPLogin(body);

        // if (response.status === "OK") {
        //   setTimeout(() => {
        //     message.success("Login Success");
        //   }, 1000);

        //   setTimeout(() => {
        //     setLoadingOtp(false);
        //     setShowModalOTP(false);

        //     const body = {
        //       username: form.getFieldValue("username"),
        //       password: form.getFieldValue("password"),
        //       device: device,
        //       application: application,
        //       app_id: oneUserAppId,
        //     };

        dispatch(showAuthLoader());
        dispatch(userSignIn(body));
        // }, 1400);
        // }
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Kode OTP salah, mohon coba lagi";

      setLoadingOtp(false);
      if (errorMsg.includes("OTP_NOT_MATCH")) {
        setLoadingOtp(false);
        message.error("Kode OTP Tidak Sesuai, mohon coba lagi");
      } else {
        setLoadingOtp(false);
        message.error("Kode OTP salah, mohon coba lagi");
      }
    }
  };

  const onResendOtp = async () => {
    try {
      setLoadingOtp(true);
      const body = {
        // user_id: encrypt(email),
        username: form.getFieldValue("username"),
      };
      const response = await resendOTP(body);
      if (response.status === "OK") {
        setTimeout(() => {
          setLoadingOtp(false);
          message.success("OTP berhasil dikirim, silahkan cek email anda");
          setCounter(90);
        }, 1000);
      }
    } catch (error) {
      setLoadingOtp(false);
      console.log(error);
      message.success("Terjadi kesalahan saat mengirim OTP, mohon coba lagi");
    }
  };

  const year = moment().format("YYYY");

  const handleOtpChange = (val) => {
    // bersihkan, pastikan hanya digit dan maksimal 6
    const cleaned = val.replace(/\D/g, "").slice(0, 6);
    setDataOtp(cleaned); // update state
  };

  const openCaptchaModal = (
    <Modal
      visible={openCaptcha}
      maskClosable={false}
      footer={null}
      // onCancel={() => setOpenCaptcha(false)}
      centered
      className="captcha-modal"
      closable={false}
    >
      <Row className="captcha-row-1">
        <Col span={21}>
          <div className="captcha-title">Captcha</div>
        </Col>
        <Col span={3}>
          <Tooltip title="Reload Captcha" placement="top">
            <Button
              // type="primary"
              className="restart-captcha-button redo-button"
              onClick={() => {
                onFinishLogin(oneUserAppId);
                captchaForm.resetFields();
              }}
            >
              <RedoOutlined style={{ fontSize: 20 }} />
            </Button>
          </Tooltip>
        </Col>
      </Row>
      <Row className="captcha-row-2">
        <div className="captcha-container">
          {captchaSuccess ? (
            <div className="captcha-success">
              <CheckCircleFilled className="captcha-success-check" />
              <div className="captcha-success-text">
                <IntlMessages id="app.userAuth.captchaSuccess" />
              </div>
            </div>
          ) : loadingCaptcha ? (
            <Spin
              size="large"
              tip={<div style={{ fontWeight: "normal" }}>Loading</div>}
              className="captcha-loading"
            />
          ) : captcha?.length !== 0 ? (
            <>
              <img
                src={captchaBg?.background}
                style={{ transform: `rotate(${captchaBg?.bgRotate}deg)` }}
                className={`login-captcha-bg`}
                alt="bg"
              />
              <div className="login-captcha-content">
                {captcha?.map((data, idx) => {
                  return (
                    <img
                      className="login-captcha-image"
                      src={data.image}
                      key={idx}
                      style={{
                        paddingTop: `${data?.position}px`,
                        transform: `rotate(${data.rotates}deg)`,
                      }}
                      alt="captcha-img"
                    />
                  );
                })}
              </div>
            </>
          ) : (
            <Spin
              size="large"
              tip={<div style={{ fontWeight: "normal" }}>Loading</div>}
              className="captcha-loading"
            />
          )}
        </div>
      </Row>
      <Form
        method="post"
        form={captchaForm}
        preserve={false}
        onFinish={(values) => onVerifyCaptcha(values)}
        validateTrigger="onSubmit"
      >
        <Row className="captcha-row-3" style={{ justifyContent: "center" }}>
          <Col span={18} className="captcha-form-field">
            <Form.Item
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="app.userAuth.captchaFill" />,
                },
              ]}
              name="captchaInput"
            >
              <div className="captcha-input-container">
                <Input
                  placeholder="Enter captcha"
                  className="captcha-input"
                  // onChange={(event) => onChangeInputCaptcha(event.target.value)}
                  disabled={loadingCaptcha}
                />
              </div>
            </Form.Item>
          </Col>
          <Col span={5} className="captcha-form-field">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className={
                  captchaSuccess
                    ? "success-captcha-button verify-button captcha-button"
                    : "restart-captcha-button verify-button captcha-button"
                }
                loading={Loading}
              >
                <IntlMessages id="app.userAuth.buttonVerification" />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  const openOtpModal = (
    <Modal
      className="otp-modal"
      visible={showModalOTP}
      // onOk={handleOtpLogin}
      // onCancel={ShowHideModalOTP}
      // confirmLoading={Loading}
      footer={null}
      centered={true}
      destroyOnClose={true}
      maskClosable={false}
    >
      <div className="otp-title mb-3">
        <IntlMessages id="app.userAuth.otpVerification" />
      </div>
      <div className="otp-note-container">
        <div className="otp-text-small">
          <IntlMessages id="app.userAuth.checkEmail" />
        </div>
        <div className="otp-text-small">{email}</div>
        <div className="otp-text-small">
          <IntlMessages id="app.userAuth.lookingOtp" />
        </div>
      </div>
      <div className="otp-input-container">
        <Form
          method="post"
          form={otpForm}
          preserve={false}
          onFinish={(values) => onVerifyOTP(values)}
          validateTrigger="onSubmit"
        >
          <div className="otp-code">
            <IntlMessages id="app.userAuth.otpCode" />
          </div>
          <div
            className="otp-filed"
            style={{ display: "flex", justifyContent: "center", gap: 8 }}
          >
            <OtpInput length={6} onChange={handleOtpChange} />
            {/* <Form.Item
              name="otpInput"
            >
              {dataOtp.map((digit, index) => (
              <Input
                key={index}
                maxLength={1}
                value={digit}
                style={{
                  width: 50,
                  height: 50,
                  textAlign: "center",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
                disabled={loadingOtp}
              />
              ))}
            </Form.Item> */}
          </div>

          <div className="otp-button-container">
            <Form.Item>
              <Button
                type="primary"
                className="otp-button"
                htmlType="submit"
                loading={loadingOtp}
              >
                <IntlMessages id="app.userAuth.buttonVerification" />
              </Button>
            </Form.Item>
          </div>
          <div className="otp-resend-button-container">
            <div
              className={`resend-otp-button ${counter === 0 ? "" : "disabled"}`}
              onClick={() => (counter === 0 ? onResendOtp() : null)}
            >
              Kirim ulang kode
            </div>
            <div>{secondsToTime(counter)}</div>
          </div>
        </Form>
      </div>
    </Modal>
  );

  const modalConfirm = (
    <Modal
      visible={openModal}
      footer={null}
      style={{ overflow: "visible" }}
      onCancel={() => {
        closeModal();
      }}
      centered
      maskClosable={false}
      className="confirm-modal"
      title={""}
      destroyOnClose
      closable={false}
      width={"21.188rem"}
    >
      <div className="modal-suspend">
        <div className="suspend-icon">
          <CloseCircleOutlined />
        </div>
        <div className="suspend-title">
          <span>
            <IntlMessages id="app.userAuth.accountLock" />
          </span>
        </div>

        <div className="suspend-container">
          <div className="suspend-detail">
            <IntlMessages id="app.userAuth.accountUnlock" />
          </div>
        </div>

        <div className="suspend-container-button">
          <div className="suspend-button">
            <Button
              type="primary"
              className="modal-confirm-cancel-button"
              onClick={() => closeModal()}
            >
              <IntlMessages id="app.userAuth.buttonClose" />
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );

  return (
    <Fragment>
      <Helmet>
        <meta charSet="UTF-8" />
        <title>Login - Geospatial Analytics Center</title>
      </Helmet>
      {openCaptchaModal}
      {openOtpModal}
      {modalConfirm}
      <div className="gx-app-login-wrap gx-login-background">
        <video autoPlay loop muted id="myVideo">
          <source src={LoginVideo} type="video/mp4" />
        </video>
        <div className="gx-app-login-container">
          <div className="gx-login-logo">
            <img src={LogoBareskrim} alt="logo" />
          </div>
          <div className="gx-app-login-main-content">
            <div className="gx-app-login-content">
              <div className="gx-login-header gx-text-center">
                <h1 className="gx-login-title">GEOSPATIAL ANALYTICS CENTER</h1>
              </div>
              <Form
                initialValues={{ remember: true }}
                name="basic"
                form={form}
                // onFinish={onFinish}
                // onFinish={(values) => handleVerifyCaptcha(values)}
                onFinish={(values) => checkAppIds(values)}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
              >
                <Form.Item
                  // initialValue="admin"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessages id="app.userAuth.usernameFill" />,
                    },
                  ]}
                  name="username"
                >
                  <Input
                    placeholder="Nama Pengguna"
                    prefix={<UserOutlined className="gx-login-icon-form" />}
                  />
                </Form.Item>
                <Form.Item
                  // initialValue="udin"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessages id="app.userAuth.passwordFill" />,
                    },
                  ]}
                  name="password"
                >
                  <Input.Password
                    type="password"
                    placeholder="Kata Sandi"
                    prefix={<LockOutlined className="gx--login-icon-form" />}
                  />
                </Form.Item>
                <Form.Item className="gx-text-center">
                  <Button
                    type="primary"
                    className="gx-mb-0"
                    htmlType="submit"
                    loading={Loading}
                  >
                    LOGIN
                  </Button>
                </Form.Item>
                <p className="gx-text-light gx-fs-sm gx-login-copyright">
                  {" "}
                  © {year} All Right Reserved
                </p>
              </Form>
            </div>
            {loader ? (
              <div className="gx-loader-view">
                <CircularProgress />
              </div>
            ) : null}
            {showMessage ? message.error(alertMessage.toString()) : null}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SignIn;
